import { render, staticRenderFns } from "./SolicitacaoVisualizarAtendimento.vue?vue&type=template&id=f3bf1766"
import script from "./SolicitacaoVisualizarAtendimento.vue?vue&type=script&lang=js"
export * from "./SolicitacaoVisualizarAtendimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports